import { gql } from 'graphql-tag';

export const MESSAGE_FIELDS = gql`
  fragment MessageFields on Message {
    id
    body
    kind
    readAt
    created_at
    sender {
      id
      name
    }
  }
`;

export const CONVERSATION_LIST_FIELDS = gql`
  fragment ConversationListFields on Conversation {
    id
    unread
    lastMessageAt
    listingPost {
      id
      title
    }
    owner {
      id
      name
      plot {
        id
        name
        slug
        description
        avatarUrls {
          thumbUrl
          mediumUrl
        }
        profilePhotoUrl
        user {
          id
          name
        }
      }
    }
    guest {
      id
      name
      plot {
        id
        name
        slug
        description
        avatarUrls {
          thumbUrl
          mediumUrl
        }
        profilePhotoUrl
        user {
          id
          name
        }
      }
    }
    lastMessage {
      ...MessageFields
    }
  }
  ${MESSAGE_FIELDS}
`;

export const CONVERSATION_DETAIL_FIELDS = gql`
  fragment ConversationDetailFields on Conversation {
    ...ConversationListFields
    status
    participants {
      id
      role
      lastReadAt
      isMuted
      user {
        id
        name
      }
    }
  }
  ${CONVERSATION_LIST_FIELDS}
`;

export const NOTIFICATION_FIELDS = gql`
  fragment NotificationFields on AppNotification {
    id
    type
    title
    bodyPreview
    data
    readAt
    created_at
    conversation {
      id
    }
    message {
      id
    }
  }
`;

export const MY_CONVERSATIONS_QUERY = gql`
  query MyConversations($first: Int = 20, $page: Int) {
    myConversations(first: $first, page: $page) {
      pageInfo {
        hasNextPage
        currentPage
        lastPage
        total
        count
      }
      edges {
        cursor
        node {
          ...ConversationListFields
        }
      }
    }
  }
  ${CONVERSATION_LIST_FIELDS}
`;

export const CONVERSATION_QUERY = gql`
  query Conversation($id: ID!) {
    conversation(id: $id) {
      ...ConversationDetailFields
    }
  }
  ${CONVERSATION_DETAIL_FIELDS}
`;

export const CONVERSATION_MESSAGES_QUERY = gql`
  query ConversationMessages($conversation_id: ID!, $first: Int = 20, $page: Int) {
    conversationMessages(conversation_id: $conversation_id, first: $first, page: $page) {
      pageInfo {
        hasNextPage
        currentPage
        lastPage
        total
        count
      }
      edges {
        cursor
        node {
          ...MessageFields
        }
      }
    }
  }
  ${MESSAGE_FIELDS}
`;

export const MY_NOTIFICATIONS_QUERY = gql`
  query MyNotifications($first: Int = 20, $page: Int, $unreadOnly: Boolean = false) {
    myNotifications(first: $first, page: $page, unread_only: $unreadOnly) {
      pageInfo {
        hasNextPage
        currentPage
        lastPage
        total
        count
      }
      edges {
        cursor
        node {
          ...NotificationFields
        }
      }
    }
  }
  ${NOTIFICATION_FIELDS}
`;

export const MY_UNREAD_COUNT_QUERY = gql`
  query MyUnreadCount {
    myUnreadCount {
      unread_conversations
      unread_notifications
      total_badge_count
    }
  }
`;

export const START_LISTING_CONVERSATION_MUTATION = gql`
  mutation StartListingConversation($postId: ID!) {
    startListingConversation(post_id: $postId) {
      ...ConversationDetailFields
    }
  }
  ${CONVERSATION_DETAIL_FIELDS}
`;

export const START_PLOT_CONVERSATION_MUTATION = gql`
  mutation StartPlotConversation($plotId: ID!) {
    startPlotConversation(plot_id: $plotId) {
      ...ConversationDetailFields
    }
  }
  ${CONVERSATION_DETAIL_FIELDS}
`;

export const SEND_MESSAGE_MUTATION = gql`
  mutation SendMessage($conversationId: ID!, $body: String!) {
    sendMessage(conversation_id: $conversationId, body: $body) {
      ...MessageFields
    }
  }
  ${MESSAGE_FIELDS}
`;

export const MARK_CONVERSATION_READ_MUTATION = gql`
  mutation MarkConversationRead($conversationId: ID!) {
    markConversationRead(conversation_id: $conversationId)
  }
`;

export const MARK_NOTIFICATIONS_READ_MUTATION = gql`
  mutation MarkNotificationsRead($ids: [ID!], $all: Boolean = false) {
    markNotificationsRead(ids: $ids, all: $all)
  }
`;
